module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Text 文本框")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('form', {
    staticClass: "flex-grid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"row form-group\">\n  <label class=\"label align-right cell\">文本框</label>\n  <div class=\"input-control cell colspan4\">\n    <input type=\"text\">\n  </div>\n</div>\n<div class=\"row form-group\">\n  <label class=\"label align-right cell\">密码</label>\n  <div class=\"input-control cell colspan4\">\n    <input type=\"password\">\n  </div>\n</div> ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "no-margin fg-gray"
  }, [_vm._v("带Placehoder")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', {
    staticClass: "no-margin fg-gray"
  }, [_vm._v("Readonly 只读状态")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h5', {
    staticClass: "no-margin fg-gray"
  }, [_vm._v("Disabled 禁用状态")]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Text field states 文本框状态")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("1. error")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("2. warning")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("3. success")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h5', {
    staticClass: "no-margin"
  }, [_vm._v("4. required")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"input-control error\">\n    <input type=\"text\">\n</div>\n<div class=\"input-control warning\">\n    <input type=\"text\">\n</div>\n<div class=\"input-control success\">\n    <input type=\"text\">\n</div>\n  <div class=\"input-control required\">\n  <input type=\"text\">\n</div>\n")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Input with buttons 带按钮的输入框")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"input-control text\" style=\"width: 300px;\">\n  <input type=\"text\" placeholder=\"Search ...\" style=\"padding-right: 58px;\">\n  <button class=\"button\">\n    <i class=\"fa fa-search\"></i></button>\n</div>\n")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("文本")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "password"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "请输入您的Email地址"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("Readonly")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "value": "Readonly",
      "readonly": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "label align-right cell"
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('div', {
    staticClass: "input-control cell colspan4"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control error"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control warning"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control success"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control required"
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-control text",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('input', {
    staticStyle: {
      "padding-right": "58px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search ..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a9fbbe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/input.vue
// module id = 401
// module chunks = 1